import { z } from 'zod/v4-mini';

import { Schema, cz } from '@/utils/zodUtils.ts';

import {
  FrenchIdentity,
  frenchIdentitySchema,
} from './identity/FrenchIdentity';

/*********************************
 *            Patient            *
 *********************************/

export type PatientID = {
  id: string;
};

export const patientIDSchema: Schema<PatientID> = z.object({
  id: z.string(),
});

export type MessageCountType = {
  sent_by_patient: number;
  sent_by_practitioner_to_all: number;
  sent_by_practitioner_to_practitioner: number;
  sent_by_dg_patient: number;
};

export const messageCountSchema: Schema<MessageCountType> = z.object({
  sent_by_patient: z.number(),
  sent_by_practitioner_to_all: z.number(),
  sent_by_practitioner_to_practitioner: z.number(),
  sent_by_dg_patient: z.number(),
});

export type Patient = {
  id: string;
  givenName: string;
  familyName: string;
  contactPhone: string;
  email: string;
  addressLine?: string;
  addressPostalCode?: string;
  addressCity?: string;
  weight?: number;
  last_login?: string;
} & FrenchIdentity;

export const patientSchema: Schema<Patient> = z.intersection(
  frenchIdentitySchema,
  z.object({
    id: z.string(),
    givenName: z.string(),
    familyName: z.string(),
    contactPhone: z.string(),
    email: z.string(),
    addressLine: cz.optional(z.string()),
    addressPostalCode: cz.optional(z.string()),
    addressCity: cz.optional(z.string()),
    weight: cz.optional(z.number()),
    last_login: cz.optional(cz.datetime()),
  }),
);
